import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';

import { BomPartNumber } from 'bom/elements';
import { getAgGridTableCellData } from 'core/utils';
import { IPartBomItem } from 'partBoms/types';
import { PartDetails } from 'parts/components';
import { PartNumberHelper } from 'parts/helpers';

export const PartNumberCell = (props: ICellRendererParams) => {
  const [selectedItem, setSelectedItem] = useState<IPartBomItem | null>(null);

  const data = getAgGridTableCellData(props, 'part') as IPartBomItem;

  const isGroupedByColumn = props?.node?.rowGroupColumn?.getColId() === 'part';

  if (!data || isGroupedByColumn) {
    return PartNumberHelper.toLabel(props?.value);
  }

  return (
    <>
      <BomPartNumber bomPart={data} onPartClick={() => setSelectedItem(data)} />

      <PartDetails
        isOpen={!!selectedItem?.id}
        onClose={() => setSelectedItem(null)}
        part={selectedItem?.partArr}
        slidingPanelProps={{
          inheritContentWidth: true,
          autoWidth: true,
          level: 1,
        }}
      />
    </>
  );
};
